module.exports = "/_next/static/images/PersonalizationGraphData-f35ec04c18b52e12fa4baeb25429f33a.png";